import React from 'react';
import styles from './Advertising.module.css';

const FIELDS = [
  { key: 'imageUrl', label: 'Banner image (light)', preview: 'light' },
  { key: 'imageUrlDark', label: 'Banner image (dark)', preview: 'dark' },
  { key: 'wideBannerImageUrl', label: 'Wide banner (light)', preview: 'light' },
  { key: 'wideBannerImageUrlDark', label: 'Wide banner (dark)', preview: 'dark' },
];

export default function AdImageFields({ ad, uploadingField, onChange, onUpload }) {
  return (
    <div className={styles.imageFields}>
      {FIELDS.map((field) => {
        const url = ad[field.key] || '';
        return (
          <div key={field.key}>
            <label className={styles.label}>{field.label}</label>
            <input
              type="file"
              accept="image/png,image/jpeg,image/jpg,image/webp"
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (file) onUpload(field.key, file);
                e.target.value = '';
              }}
              disabled={uploadingField === field.key}
            />
            {uploadingField === field.key && <p className={styles.hint}>Uploading…</p>}
            <label className={styles.subLabel} htmlFor={`ad-${field.key}`}>
              {field.key}
            </label>
            <input
              id={`ad-${field.key}`}
              type="text"
              className={styles.field}
              value={url}
              onChange={(e) => onChange(field.key, e.target.value)}
            />
            {url && (
              <img
                src={url}
                alt={`${field.label} preview`}
                className={field.preview === 'dark' ? styles.previewDark : styles.previewLight}
              />
            )}
          </div>
        );
      })}
      <div>
        <label className={styles.label} htmlFor="ad-image-fit">
          Banner image fit
        </label>
        <select
          id="ad-image-fit"
          className={styles.field}
          value={ad.imageFit || ''}
          onChange={(e) => onChange('imageFit', e.target.value)}
        >
          <option value="">Default</option>
          <option value="centerAndFill">centerAndFill</option>
        </select>
      </div>
    </div>
  );
}
